serverError:
    en: 'Oops! A server error has occurred. Try again or report to support team.'
    ru: 'Упс! Серверная ошибка. Попробуйте снова или сообщите об этом в службу поддержки.'
    pt: 'Oops! Ocorreu um erro no servidor. Tente outra vez ou reporte à equipa de suporte'
serverWarning:
    en: 'Server warning'
    ru: 'Предупреждение сервера'
    pt: 'Aviso do servidor'
authenticationExpired:
    en: 'Authentication expired'
    ru: 'Истек срок действия аутентификации'
    pt: 'A autenticação expirou'
longRequest:
    en: 'Long request'
    ru: 'Долгий запрос'
    pt: 'Tempo de pedido excedido'
technicalInformation:
    en: 'Technical information'
    ru: 'Технические подробности'
    pt: 'Informação Técnica'
serverWrongResponse:
    en: 'Server responded with code'
    ru: 'Сервер ответил кодом'
    pt: 'O servidor respondeu com um código'
reportProblem:
    en: 'Report a problem'
    ru: 'Сообщить о проблеме'
    pt: 'Reportar um problema'
serverErrorTitle:
    en: 'Server error'
    ru: 'Ошибка сервера'
    pt: 'Erro do servidor'
customer-location-can-not-be-removed:
    en: "Customer location '{0}' can not be removed. There are {1} order(s) created for it"
    ru: "Расположение клиента '{0}' невозможно удалить, так как для него есть заказы в количестве {1}"
    es: "La localización del cliente '{0}' no se puede borrar. Hay {1} pedido(s) creados para ellos"
    pt: "A localização do cliente '{0}' não pode ser removida. Há {1} pedidos criados para isso"
vehicle-form-attached-to-vehicle:
    en: 'Cannot delete vehicle check form. It is assigned to a vehicle'
    ru: 'Невозможно удалить форму проверки. Форма назначена на машину'
    es: 'No se puede eliminar el formulario de revisión de vehículos. Está asignado a un vehículo'
    pt: 'Não é possível eliminar o formulário de verificação de veículo. É atribuído a um veículo'
